export default from './Description';



// WEBPACK FOOTER //
// ./src/components/NonAuthHomePage/components/Description/index.js